import { DateDataTypeIcon } from 'foundations-assets/icons/components/DateDataTypeIcon';
import { MenuIcon } from 'foundations-assets/icons/components/MenuIcon';
import { MarketingIcon } from 'foundations-assets/icons/components/MarketingIcon';
import { RecentlySelectedIcon } from 'foundations-assets/icons/components/RecentlySelectedIcon';
import { UserIcon } from 'foundations-assets/icons/components/UserIcon';
export const ICONS = {
  status: MenuIcon,
  __requested_by_full_name_or_email: MarketingIcon,
  createdate: DateDataTypeIcon,
  hs_lastactivitydate: RecentlySelectedIcon,
  __hubspot_owner_full_name: UserIcon
};
export const CONFIGURED_PROPERTIES_PRIORITY_ORDER = ['status', '__requested_by_full_name_or_email', 'createdate', 'hs_lastactivitydate', '__hubspot_owner_full_name'];